import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { debug } from '../lib/debug'

export function useResponseCount(surveyCode: string) {
  const [count, setCount] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let mounted = true
    let subscription: any = null

    const fetchCount = async () => {
      try {
        debug('SURVEY_CREATOR', `Fetching count for survey ${surveyCode}`)
        const { count: responseCount, error } = await supabase
          .from('survey_responses')
          .select('*', { count: 'exact', head: true })
          .eq('survey_code', surveyCode)
          .eq('status', 'completed')

        if (error) throw error

        if (mounted) {
          debug('SURVEY_CREATOR', `Found ${responseCount || 0} responses for survey ${surveyCode}`)
          setCount(responseCount || 0)
        }
      } catch (err) {
        console.error('Error fetching response count:', err)
        if (mounted) {
          setError(err as Error)
        }
      } finally {
        if (mounted) {
          setIsLoading(false)
        }
      }
    }

    fetchCount()

    // Subscribe to changes
    subscription = supabase
      .channel(`survey_responses:${surveyCode}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'survey_responses',
          filter: `survey_code=eq.${surveyCode}`
        },
        () => {
          if (mounted) {
            fetchCount()
          }
        }
      )
      .subscribe()

    return () => {
      debug('SURVEY_CREATOR', `Unsubscribing from survey ${surveyCode} changes`)
      mounted = false
      if (subscription) {
        subscription.unsubscribe()
      }
    }
  }, [surveyCode])

  return { count, isLoading, error }
}